import React from 'react';

const WorkProcess = () => {
    return (
        <>
            <div className="process__area" style={{ paddingTop: "60px" }}>
                <div className="container">
                    <div className="row mb-75">
                        <div className="col-xl-12">
                            <div className="process__area-title t-center">
                                <span className="subtitle wow fadeInLeft" data-wow-delay=".4s">PROJE GELİŞTİRME</span>
                                <h2 
  className="wow fadeInRight" 
  data-wow-delay=".6s" 
  style={{ fontSize: "36px" }}
>
Proje Süreç Yönetimi
</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row g-0">
                        <div className="col-lg-3 col-md-6 lg-mb-40 wow fadeInLeft" data-wow-delay=".3s">
                            <div className="process__area-item">
                                <h6>01</h6>
                                <h4>Danışmanlık ve Proje Sunumu</h4>
                                <p>Projenize özel ön görüşme gerçekleştirilir, ihtiyaçlar detaylı şekilde analiz edilir ve en uygun çözüm yaklaşımı profesyonel olarak sunulur.</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 md-mb-40 wow fadeInLeft" data-wow-delay=".6s">
                            <div className="process__area-item pl-0 xl-pl-0">
                                <h6>02</h6>
                                <h4>Keşif ve Teklif Süreci</h4>
                                <p>Saha incelemesi yapılır, proje gereksinimleri doğrultusunda sözleşme şartlarına uygun detaylı ve şeffaf teklif hazırlanır.</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 md-mb-40 wow fadeInLeft" data-wow-delay=".9s">
                            <div className="process__area-item pl-0 xl-pl-0">
                                <h6>03</h6>
                                <h4>İhale ve Planlama</h4>
                                <p>Proje ihale sürecine alınır; teknik detaylar netleştirilir ve tüm operasyonel planlama eksiksiz şekilde oluşturulur.</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 wow fadeInLeft" data-wow-delay="1.2s">
                            <div className="process__area-item pl-0 xl-pl-0">
                                <h6>04</h6>
                                <h4>Anahtar Teslim Uygulama</h4>
                                <p>Tüm süreç uzman ekiplerimiz tarafından yönetilir, proje zamanında ve eksiksiz şekilde anahtar teslim olarak tamamlanır.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>            
        </>
    );
};

export default WorkProcess;